import { ensureArray } from '~/lib/helpers/ensureArray'
import Loading from '~/components/shared/Loading'
import Error from '~/components/shared/Error'

/**
 * For apollo data, returns error or loading or data needed accordingly
   Ex: const { unready, users } = dataUnready(data, 'users')
   Ex: const { unready, users, roles } = dataUnready(data, ['users', 'roles'])
 * @param {Object} data
 * @param {string} keysIn
 * @param {boolean} showReloading
 * @return returns <Loading />, Error or keysData
 */
function dataUnready (data: any, keysIn: object, showReloading: boolean) {
  if (!data || (keysIn === undefined && data.loading)) {
    return { unready: <Loading /> }
  } else if (data.error) {
    return { unready: <Error error={data.error} /> }
  } else {
    const keys = ensureArray(keysIn)
    const keysData = {}
    let loading = false
    for (const key of keys) {
      keysData[key] = data[key]
      if (keysData[key] === undefined) {
        loading = true
      }
    }

    if (data.loading && (loading || showReloading)) {
      return { unready: <Loading /> }
    } else {
      return keysData
    }
  }
}

export { dataUnready }
